import type { CommentDto, CreateCommentRequest } from '../Models/Task'
import { tasksAxios } from './tasksApi'

export const commentsApi = {
  getByTaskId: (taskId: string) =>
    tasksAxios
      .get<CommentDto[]>(`/GetTaskComments/${encodeURIComponent(taskId)}`)
      .then((r) => r.data),
  create: (taskId: string, body: string) =>
    tasksAxios
      .post<CommentDto>(`/CreateTaskComment/${encodeURIComponent(taskId)}`, {
        body,
      } satisfies CreateCommentRequest)
      .then((r) => r.data),
  delete: (taskId: string, id: string) =>
    tasksAxios.delete(
      `/DeleteTaskComment/${encodeURIComponent(taskId)}/${encodeURIComponent(id)}`
    ),
}
